import * as React from "react";
function ChatBubbleSadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139 139",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3 .5A2.5 2.5 0 00.5 3v99.5A2.5 2.5 0 003 105h37v21a2.5 2.5 0 004.268 1.768L67.035 105H136.5a2.5 2.5 0 002.5-2.5V3a2.5 2.5 0 00-2.5-2.5H3zM5.5 100V5.5H134V100H66a2.5 2.5 0 00-1.768.732L45 119.964V102.5a2.5 2.5 0 00-2.5-2.5h-37zM52 46a7 7 0 100-14 7 7 0 000 14zm35 0a7 7 0 100-14 7 7 0 000 14zM58.042 66.994C60.308 63.992 63.872 61.5 69 61.5c5.14 0 8.64 2.505 10.81 5.548 2.1 2.945 2.986 6.404 3.181 8.744a2.5 2.5 0 11-4.983.416c-.138-1.66-.803-4.201-2.268-6.256C74.343 67.995 72.26 66.5 69 66.5c-3.273 0-5.459 1.508-6.968 3.506-1.57 2.081-2.344 4.642-2.551 6.304a2.5 2.5 0 01-4.962-.62c.292-2.338 1.319-5.777 3.523-8.696z"
  }));
}
const ForwardRef = React.forwardRef(ChatBubbleSadIcon);
export default ForwardRef;